export default __webpack_public_path__ + "static/media/ic-lang.47090d06.svg";